#import '../fragment/productTechnical.graphql'

query productTechnical($customerId: ID!, $contractId: ID!, $productId: ID!) {
  productTechnical(customerId: $customerId, contractId: $contractId, productId: $productId) {
    ...productTechnicalFragment
  }
}
